import $ from "jquery";

export const ExtraPage = function () {
	if (!($("#extra-page").length > 0)) return false;

	const $elms = {
		btnBack: $(".js-back-btn"),
		btnPlayVideo: $(".js-play-video"),
		btnReplayVideo: $(".js-replay-video"),
		navigation: $(".js-navigation"),
		videoElement: $("#hero-video").get(0),
		videoWrapper: $(".video"),
		thumbnailCanvas: $("#video-thumbnail").get(0),
	};

	const generateThumbnail = function () {
		const video = $elms.videoElement;
		const canvas = $elms.thumbnailCanvas;

		if (video && canvas) {
			canvas.width = video.videoWidth;
			canvas.height = video.videoHeight;
			const ctx = canvas.getContext("2d");
			ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
		}
	};

	$($elms.videoElement).on("loadedmetadata", function () {
		this.currentTime = 0.1;
	});

	$($elms.videoElement).on("seeked", function () {
		generateThumbnail();
	});

	const onBtnPlayVideoClick = function () {
		const videoElement = $("#hero-video").get(0);
		const videoWrapper = $(".video");
		if (videoElement && videoElement.paused) {
			videoElement.play();
			videoElement.muted = false;
			videoWrapper.addClass("is-playing").removeClass("is-finished is-paused");
			$("#video-thumbnail").hide();
		} else {
			videoElement.pause();
			videoWrapper.removeClass("is-playing");
		}
	};

	const onBtnPauseVideoClick = function () {
		const videoElement = $("#hero-video").get(0);
		const videoWrapper = $(".video");
		if (videoElement) {
			videoElement.pause();
			videoWrapper.addClass("is-paused").removeClass("is-playing");
		}
	};

	$($elms.btnPlayVideo).on("click", function (e) {
		e.preventDefault();
		onBtnPlayVideoClick();
	});

	$($elms.btnReplayVideo).on("click", function (e) {
		e.preventDefault();
		onBtnPlayVideoClick();
	});

	$($elms.videoElement).on("ended", function () {
		$($elms.videoWrapper).addClass("is-finished");
	});

	$($elms.videoElement).on("click", function () {
		if ($($elms.videoWrapper).hasClass("is-playing")) {
			onBtnPauseVideoClick();
		}
	});

	$($elms.btnBack).on("click", function () {
		if (
			window.history.length > 1 &&
			document.referrer.indexOf(window.location.origin) === 0
		) {
			window.history.back();
		} else {
			window.location.href = "/";
		}
	});
};
